// extracted by mini-css-extract-plugin
export default {"Project":"Project_Project__TaOE3","Project__showcase":"Project_Project__showcase__E05SX"};